var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"items":_vm.srcList,"clearable":"","placeholder":_vm.holderText,"item-text":_vm.showText},on:{"change":_vm.change,"update:search-input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }